export default __webpack_public_path__ + "static/media/30.5b3bafec.png";